import { KestrelVersion } from "type/kestrel-version";

// MAX-4233: FUB redirects a logged-in user from this account-less URL to their own
// account's embedded-app page (https://{subdomain}.followupboss.com/2/integrations/
// embedded-apps/2439), so one static link serves every account and no subdomain
// needs to be captured. 2439 is the iHomefinder embedded app's FUB app id.
export const FUB_EMBEDDED_APP_URL = "https://app.followupboss.com/2/integrations/embedded-apps/2439";

// The embedded app is available to Premium, v10 accounts only. Event sync is the
// Premium-tier FUB entitlement (the wizard labels it "Premium only"), and
// kestrelVersion.all is the v10 signal — the same gate shape the Wix integration uses.
export function isEmbeddedAppEligible(user: {
    permissions: { followUpBossEventSync?: boolean };
    kestrelVersion: KestrelVersion;
}): boolean {
    return !!user.permissions.followUpBossEventSync && user.kestrelVersion.all;
}
